import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import * as jQuery from 'jquery';
import { link } from 'fs';
import { element } from 'protractor';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {

  constructor(@Inject(DOCUMENT) private dom: Document) { }

  setCanonicalURL(url?: string) {
    if ($("link[rel='canonical']").length == 0) {
      const canURL = url == undefined ? this.dom.URL : url;
      const link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
      link.setAttribute('href', canURL);
      this.dom.head.appendChild(link);
      link.setAttribute('id', 'canonical');
    } else {
      const otherurl:any = url == undefined ? this.dom.URL : url;
      document.getElementById("canonical")?.setAttribute('href', otherurl.toString());
    }
  }
}
